// openapi/services.gen.ts
import { createClient, createConfig } from "@hey-api/client-fetch";
var client = createClient(createConfig());
var plan = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v6/plan"
  });
};
var planPost = (options) => {
  return (options?.client ?? client).post({
    ...options,
    url: "/api/v6/plan"
  });
};
var oneToMany = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/one-to-many"
  });
};
var oneToManyPost = (options) => {
  return (options?.client ?? client).post({
    ...options,
    url: "/api/v1/one-to-many"
  });
};
var oneToManyIntermodal = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/experimental/one-to-many-intermodal"
  });
};
var oneToManyIntermodalPost = (options) => {
  return (options?.client ?? client).post({
    ...options,
    url: "/api/experimental/one-to-many-intermodal"
  });
};
var oneToAll = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v6/one-to-all"
  });
};
var reverseGeocode = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/reverse-geocode"
  });
};
var geocode = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/geocode"
  });
};
var trip = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v6/trip"
  });
};
var refreshItinerary = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v6/refresh-itinerary"
  });
};
var refreshItineraryPost = (options) => {
  return (options?.client ?? client).post({
    ...options,
    url: "/api/v6/refresh-itinerary"
  });
};
var stoptimes = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v6/stoptimes"
  });
};
var trips = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v6/map/trips"
  });
};
var initial = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/map/initial"
  });
};
var stops = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v6/map/stops"
  });
};
var stopInfo = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v6/stop"
  });
};
var levels = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/map/levels"
  });
};
var routes = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/experimental/map/routes"
  });
};
var routeDetails = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/experimental/map/route-details"
  });
};
var rentals = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/rentals"
  });
};
var health = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/v1/health"
  });
};
var transfers = (options) => {
  return (options?.client ?? client).get({
    ...options,
    url: "/api/debug/transfers"
  });
};

export {
  client,
  plan,
  planPost,
  oneToMany,
  oneToManyPost,
  oneToManyIntermodal,
  oneToManyIntermodalPost,
  oneToAll,
  reverseGeocode,
  geocode,
  trip,
  refreshItinerary,
  refreshItineraryPost,
  stoptimes,
  trips,
  initial,
  stops,
  stopInfo,
  levels,
  routes,
  routeDetails,
  rentals,
  health,
  transfers
};
